import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-transactions',
    templateUrl: './transactions.component.html',
    styleUrls: ['./transactions.component.scss'],
    standalone: false
})
export class TransactionsComponent implements OnInit {

  areaTestType: string;
  showForm: boolean;

  constructor(
  ) {  }

  ngOnInit() {
  }

}
